// require styles
import 'normalize.css/normalize.css';

import Vue from 'vue';
Vue.config.devtools = true;
Vue.config.performance = true;
import App from './App.vue';
import VueSVGIcon from 'vue-svgicon';
import './compiled-icons';
import Styles from './components/Styles.vue';
import Hacks from './components/Hacks.vue';
import langTexts from './lang.json';
import filters from './js/filters.js';
import { format, createLanglog } from './js/utils.js';
import VueScrollTo from 'vue-scrollto';
import Vue2TouchEvents from 'vue2-touch-events';

const langlog = createLanglog(langTexts);
const DEFAULT_LANG = 'de';

const prodev = function(prod, dev) {
    return process.env.NODE_ENV === 'production'
        ? prod
        : dev;
}

Vue.prototype.$config = {
    jsonUrl: window.__PW__ ? window.__PW__.jsonUrl : 'menu-de.json',
}

Vue.prototype.bclang = function(phrase, ...args) {
    let result = this.$config.language === DEFAULT_LANG
        ? phrase
        : langTexts[phrase] || phrase;

    langlog(phrase);

    return format(result, ...args);
};

Vue.component('Styles', Styles);
Vue.component('Hacks', Hacks);

import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

const requireComponent = require.context(
    './components',
    false,
    /[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach(fileName => {
    const component = requireComponent(fileName);
    const name = upperFirst(
        camelCase(
            fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
        )
    );

    Vue.component(
        name,
        component.default || component
    );
});

Object.keys(filters).forEach(name => {
    Vue.filter(name, filters[name]);
});

Vue.config.productionTip = false;
Vue.use(VueSVGIcon);
Vue.use(Vue2TouchEvents);
Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease",
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})
new Vue({
  render: h => h(App)
}).$mount('#app');
